import gql from 'graphql-tag';

export const UPLOAD_VIDEO_FROM_FILE = gql`
  mutation UploadVideoFromFile($title: String!, $articleGroupId: String!, $file: Upload!) {
    uploadVideoFromFile(title: $title, articleGroupId: $articleGroupId, file: $file) {
      id
      errors
    }
  }
`;
